/**
 * Direct payment routes (used for prizes)
 */
import { getCurrencySymbol } from '@/locale';
import DirectPaymentInit from '@/features/directPayment/DirectPaymentInit';
import GeneralError from '@/features/generalError/GeneralError';
import DirectPaymentSelect from '@/features/directPayment/DirectPaymentSelect';
import PaymentForm from '@/features/paymentProcess/PaymentForm';
import PaymentSuccess from '@/features/paymentProcess/PaymentSuccess';
import PaymentSubmitted from '@/features/paymentProcess/PaymentSubmitted';
import PaymentFailure from '@/features/paymentProcess/PaymentFailure';
import PaymentError from '@/features/paymentProcess/PaymentError';

const currencySymbol = getCurrencySymbol();
const directPaymentRouteSteps = 5;

const directPaymentRoutes = {
  path: '', // Path (set in router index) = /pay/:transactionId
  children: [
    {
      // We always need a transaction ID passed here, so handle any '/pay/' attempts accordingly:
      path: '',
      element: <GeneralError errorType="missing-transaction-id" />,
    },
    {
      path: ':transactionId',
      element: <DirectPaymentInit />,
    },
    {
      path: 'not-found',
      element: <GeneralError errorType="id-not-found" />,
    },
    {
      path: 'payment-select',
      element: <DirectPaymentSelect />,
    },
    {
      path: 'card-payment',
      element: <PaymentForm
        totalSteps={directPaymentRouteSteps}
        currencySymbol={currencySymbol}
        providerGroup="direct"
      />,
    },
    {
      path: 'success',
      element: <PaymentSuccess
        totalSteps={directPaymentRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'submitted',
      element: <PaymentSubmitted
        totalSteps={directPaymentRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'failure',
      element: <PaymentFailure />,
    },
    {
      path: 'error',
      element: <PaymentError />,
    },
  ],
};

export default directPaymentRoutes;
